/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/FirstRunExperience/FirstRunExperiencePanel.Props" />
import { ExternalConnection } from "Wit/Clients/Internal/Contracts/WorkItemTracking";
import { IBasePanelContentProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanelContent.Props";

export interface IBoardInfo {
    boardId: string;
    teamId: string;
    backlogLevelId: string;
    defaultWorkItemType: string;
    workItemTeamFieldName: string;
    workItemTeamFieldValue: string;
    workItemColumnField: string;
    firstColumnName: string;
}

export interface IFirstRunExperiencePanelProps extends IBasePanelContentProps {
    connection: ExternalConnection;
    projectId?: string;
    boardInfo?: IBoardInfo;
    isInteractive?: boolean;
}
